export default __webpack_public_path__ + "static/media/analytics.57089a62.svg";